export default __webpack_public_path__ + "static/media/virusorange-250-5-min.c0f0a501.png";